import axiosInstance from "./Utils/axiosInstance";

export class managerTimesheet {
  static async fetchManagerTimesheetData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/managerTimesheet",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async updateManagerTimesheetData(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/managerTimesheet ",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async addShiftManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/addShift",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async deleteShiftManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/deleteShift",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async updateShiftManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateShift",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async updateEmployeeManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateEmployee",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async addEmployeeManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/addEmployee",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async deleteEmployeeManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/deleteEmployee",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async updateHolidayManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateBranchClosure ",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async addHolidayManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/addBranchClosure  ",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async deleteHolidayManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/deleteBranchClosure",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async updateScheduleHourManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateScheduleHour",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async updateWeeklyScheduleManager(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateWeeklySchedule",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async fetchstandbydetails(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/standByDetails",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async updateStandbyTechnician(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/updateStandByDetails",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async managerTimesheetWeek(payload) {
    try {
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/allTimesheets",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  static async fecthHourAnalytics(payload) {
    try {
      let date = new Date();
      payload.offsetTime = date.getHours() + ':' + date.getMinutes();
      const { data } = await axiosInstance.post(
        "/service/timesheet-data-service/1.0/hourAnalytics",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  static async fecthRequestHour(payload) {
    try {
      let date = new Date();
      payload.offsetTime = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
      const { data } = await axiosInstance.post(
        "/service/timesheet-crud-service/1.0/recalculateAdditionalHour",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
}
